export const ARTICLES_POPULAR_ACTION_FETCH = 'articles_popular_action_fetch'

export const ARTICLES_POPULAR_MUTATIONS_ADD_ITEMS = 'articles_popular_mutations_add_items'

export const ARTICLES_POPULAR_GETTER_GET_LIST = 'articles_popular_getter_get_list'
export const ARTICLES_POPULAR_GETTER_GET_LIMITED_LIST = 'articles_popular_getter_get_limited_list'
export const ARTICLES_POPULAR_GETTER_GET_PAGE = 'articles_popular_getter_get_page'
